import { env } from "@acme/env/client";
import { initializeApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: env.PUBLIC_FIREBASE_API_KEY,
  authDomain: env.PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: env.PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: env.PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: env.PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: env.PUBLIC_FIREBASE_APP_ID,
  measurementId: env.PUBLIC_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize Messaging (only if supported)
export const messaging = (async () =>
{
  try
  {
    const isSupportedBrowser = await isSupported();

    if (isSupportedBrowser)
    {
      return getMessaging(app);
    }

    console.log("Firebase Messaging is not supported in this browser");
    return null;
  }
  catch (err)
  {
    console.error("Error initializing Firebase Messaging:", err);
    return null;
  }
})();
